<script setup lang="ts">
import { inject, Ref } from 'vue';
import { getCurrentLocale } from '@/i18n';
import { formatDate } from '@/utils/dateUtils';
import Button from 'primevue/button';
import DataTable from 'primevue/datatable';
import TableColumn from 'primevue/column';

const dialogRef = inject('dialogRef') as Ref;
const flightInfo = dialogRef?.value?.data?.flightInfo;
const flightSeatInfo = dialogRef?.value?.data?.flightSeatInfo;
const isCruise = dialogRef?.value?.data?.isCruise;
const onClose = dialogRef?.value?.options?.emits?.onClose;
const currentLanguage = getCurrentLocale();
</script>

<template>
  <div class="mt-4 flight_detail">
    <div class="detail px-4">
      <DataTable :value="flightInfo" class="w-full" showGridlines>
        <TableColumn v-if="isCruise" field="flightNo" :header="$t('worksheet.flight_number')" dataType="string" class="min-w-10rem"> </TableColumn>
        <TableColumn v-else field="flightNumber" :header="$t('worksheet.flight_number')" dataType="string" class="min-w-10rem"> </TableColumn>
        <TableColumn field="gate" :header="$t('worksheet.departure_city')" dataType="string" class="min-w-10rem"> </TableColumn>
        <TableColumn field="dest" :header="$t('worksheet.arrival_city')" dataType="string" class="min-w-10rem"> </TableColumn>
        <TableColumn field="depDate" :header="$t('worksheet.departure_date')" class="min-w-10rem">
          <template #body="{ data }">
            {{ formatDate(data?.depDate, 'dd-LLL-yyyy', true, currentLanguage) }}
          </template>
        </TableColumn>
        <TableColumn field="depTime" :header="$t('worksheet.departure_time')" dataType="date" class="min-w-10rem">
          <template #body="{ data }">
            {{ data?.depTime }}
          </template>
        </TableColumn>
        <TableColumn field="arrDate" :header="$t('worksheet.arrival_date')" dataType="date" class="min-w-10rem">
          <template #body="{ data }">
            {{ formatDate(data?.arrDate, 'dd-LLL-yyyy', true, currentLanguage) }}
          </template>
        </TableColumn>
        <TableColumn field="arrTime" :header="$t('worksheet.arrival_time')" dataType="date" class="min-w-10rem">
          <template #body="{ data }">
            {{ data?.arrTime }}
          </template>
        </TableColumn>
      </DataTable>
    </div>
    <div class="classes-available mt-4">
      <div class="mb-1">
        <div class="classes-available-header flex justify-content-between cursor-pointer">
          <div class="flex align-items-center gap-10">
            <div>{{ $t('worksheet.class_available') }}</div>
          </div>
        </div>
        <div>
          <div class="classes-available-detail">
            <div class="outbound-detail flex w-full" v-for="(flight, flightIndex) in flightSeatInfo" :key="'flight' + flightIndex">
              <div class="title w-2 p-3">{{ $t(`worksheet.${flight.type?.toLowerCase()}`) }}</div>
              <div class="title w-2 p-3">{{ flight.flight }}</div>
              <div class="flex flex-wrap pb-5 gap-1 w-10">
                <div class="p-2" v-for="(value, property) in flight.classesAvailable" :key="'outbound' + property">
                  <div class="box-bodder">{{ property }}</div>
                  <div class="box-bodder">{{ value }}</div>
                </div>
              </div>
            </div>
            <div class="p-2 flex justify-content-end flex-wrap" v-if="isCruise">
              <Button id="close-btn" :label="$t('common.buttons.ok')" @click="onClose()" />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<style lang="scss" scoped>
.min-w-10rem {
  min-width: 10rem;
}
.width-30 {
  width: 30%;
}
.width-15 {
  width: 15%;
}
.width-80 {
  width: 80%;
}
.classes-available-header,
.fares-available-header {
  color: $col-white;
  padding: 0.8rem 1.2rem;
  font-weight: 700;
}

.classes-available-detail {
  border: $border-greybd;
}

.outbound-detail {
  border-bottom: $border-greybd;
  .title {
    border-right: $border-greybd;
    min-width: 6rem;
  }
}

.return-detail {
  border-top: $border-greybd;

  .title {
    border-right: $border-greybd;
    min-width: 8rem;
  }
}

.box-bodder {
  border: $border-greybd;
  padding: 8px;
  text-align: center;
}

.classes-available-header {
  background-color: $col-primary;
}
</style>
